export class EditEinvoiceForm {
    fkey?: string[];
    Buyer?: string;
    ComAddress?: string;
    ComName?: string;
    ComTaxCode?: string;
    ComEmail?: string;
    ComEmailCC?: string;
    ComBudgetUnitCode?: string;
    Status?: number;
    Group?: number;
}
